(function() {
  var style = document.createElement('style');
      style.textContent = '.star-set-image::before, .star-set-image::after { -webkit-transition: none !important; transition: none !important; } bundle-swatch .star-set-image { border-radius: 80px !important; }';
  document.head.appendChild(style);
})();



if (!customElements.get('bundle-selector')) {
  customElements.define('bundle-selector', class BundleSelector extends HTMLElement {
    constructor() {
      super()

      setTimeout(() => {

        const allPack = this.querySelectorAll('.product-pack')

        allPack.forEach(item => item.addEventListener('click', e => {
          allPack.forEach(item => item.classList.remove('selected'))

          const target = e.target.closest('.product-pack')
          target.classList.add('selected')
          const available = target.getAttribute('data-available') === 'true'
          const hasValidVariantId = /^\d+$/.test(target.getAttribute('data-var-id') || '')
          const purchasable = available && hasValidVariantId

          if (!purchasable) {
            this.querySelector('.bundle-btn').style.display = 'none'
            this.querySelector('.bundle-btn.sold-out').style.display = 'flex'
            this.querySelector('.bundle-btn.sold-out span').innerHTML = target.getAttribute('data-coming-text')
            // return
          } else {
            this.querySelector('.bundle-btn').style.display = 'flex'
            this.querySelector('.bundle-btn.sold-out').style.display = 'none'
          }

          const size = target.getAttribute('data-size')

          // Get all swatches
          const swatch1 = document.querySelector('bundle-swatch[data-size="1"]')
          const swatch2 = document.querySelector('bundle-swatch[data-size="2"]')
          const swatch3 = document.querySelector('bundle-swatch[data-size="3"]')

          // Hide all swatches first
          if (swatch1) swatch1.style.display = 'none'
          if (swatch2) swatch2.style.display = 'none'
          if (swatch3) swatch3.style.display = 'none'

          if (size === '1') {
            // 1x: Show only swatch 1
            if (swatch1) swatch1.style.display = 'block'
            this.selectedSize = 1
          } else if (size === '2') {
            // 2x: Show only swatch 2
            if (swatch2) {
              swatch2.style.display = 'block'
            } else {
              // Fallback if swatch2 doesn't exist
              const btn = this.querySelector('.bundle-btn')
              if (btn) btn.setAttribute('data-id', target.getAttribute('data-var-id'))
            }
            this.selectedSize = 2
          } else if (size === '3') {
            // 3x: Show only swatch 3
            if (swatch3) {
              swatch3.style.display = 'block'
            } else {
              // Fallback if swatch3 doesn't exist
              const btn = this.querySelector('.bundle-btn')
              if (btn) btn.setAttribute('data-id', target.getAttribute('data-var-id'))
            }
            this.selectedSize = 3
          }

          this.computePrice()
          setTimeout(() => {
            const stateSwatch = this.querySelector(`bundle-swatch[data-size="${this.selectedSize}"]`) || this.querySelector('bundle-swatch')
            if (stateSwatch) stateSwatch.checkSoldOutState()
          }, 50)
        }))

        const withPack = this.querySelector('.with-pack')
        if (withPack) withPack.addEventListener('click', e => {
          const target = e.target.closest('.with-pack')
          target.classList.toggle('selected')

          this.selectedWith = target.classList.contains('selected')

          this.computePrice()
        })

        this.querySelector('.bundle-btn').addEventListener('click', async (e) => {
          const parseVariantId = value => {
            if (!/^\d+$/.test(value || '')) return null

            const parsedValue = Number.parseInt(value, 10)
            return Number.isSafeInteger(parsedValue) && parsedValue > 0 ? parsedValue : null
          }

          const showUnavailableState = () => {
            this.querySelector('.bundle-btn').style.display = 'none'
            this.querySelector('.bundle-btn.sold-out').style.display = 'flex'
          }

          const selectedPack = this.querySelector('.product-pack.selected')
          const selectedPackVariantId = parseVariantId(selectedPack?.getAttribute('data-var-id'))
          const selectedPackAvailable = selectedPack?.getAttribute('data-available') === 'true'
          const currentSwatch = this.querySelector(`bundle-swatch[data-size="${this.selectedSize}"]`)
          const hasSelectedSoldOutSwatch = Boolean(
            currentSwatch?.querySelector('.swatch-custom-image.swatch-selected.sold-out')
          )

          if (!selectedPackAvailable || selectedPackVariantId === null || hasSelectedSoldOutSwatch) {
            showUnavailableState()
            return
          }

          const addArr = []

          if (!this.hasAllSwatchSelected()) {
            this.querySelector('.warning-text').style.display = 'block'
            return
          } else {
            this.querySelector('.warning-text').style.display = 'none'
          }

          // Helper function to add to cart
          const addToCart = () => {
            if (!this.querySelector('.bundle-btn').classList.contains('loading')) {
              this.querySelector('.bundle-btn').classList.add('loading')
            }
            CartJS.addItems(addArr)

            if (this.querySelector('.bundle-btn').getAttribute('data-confetti') === 'true') {
              triggerConfetti(this.querySelector('.bundle-btn'))
            }

            const observer = new MutationObserver((mutations) => {
              const cartPopup = document.getElementById('CartPopup')
              if (cartPopup) {
                this.querySelector('.bundle-btn').classList.remove('loading')
                observer.disconnect()
              }
            })

            observer.observe(document.body, {
              childList: true,
              subtree: true
            })
          }

          if (this.selectedWith) {
            addArr.push({
              id: this.querySelector('.with-pack').getAttribute('data-id'),
              quantity: 1,
            })
          }

          // FIXED: Get variant ID based on selectedSize
          // Find the currently visible swatch based on selectedSize
          if (currentSwatch && currentSwatch.style.display !== 'none') {
            // Get all selected option_value_ids from CURRENT swatch only (based on selectedSize)
            const selectedOptionValueIds = Array.from(
              currentSwatch.querySelectorAll('.swatch-custom-image.swatch-selected')
            ).map(item => item.getAttribute('data-option-value-id')).filter(id => id)

            console.log(`Selected option_value_ids for size ${this.selectedSize}:`, selectedOptionValueIds)

            if (selectedOptionValueIds.length > 0) {
              const handle = this.getAttribute(`data-size${this.selectedSize}-handle`)

              // Fetch product with option_values to get the exact variant ID
              this.querySelector('.bundle-btn').classList.add('loading')
              fetch(`/products/${handle}?option_values=${selectedOptionValueIds.join(',')}&section_id=product-variants`)
                .then(response => response.text())
                .then(html => {
                  const parser = new DOMParser()
                  const doc = parser.parseFromString(html, 'text/html')
                  const variantIdInput = doc.querySelector('#product-variants-id')

                  if (variantIdInput && variantIdInput.value) {
                    const variantId = parseVariantId(variantIdInput.value)

                    if (variantId === null) {
                      console.error('Invalid variant ID in response')
                      this.querySelector('.bundle-btn').classList.remove('loading')
                      showUnavailableState()
                      return
                    }

                    console.log(`Adding variant ${variantId} for ${this.selectedSize}x bundle`)
                    addArr.push({
                      id: variantId,
                      quantity: 1,
                    })
                    addToCart()
                  } else {
                    console.error('Variant ID not found in response')
                    this.querySelector('.bundle-btn').classList.remove('loading')
                    alert('Unable to find variant. Please try again.')
                  }
                })
                .catch(error => {
                  console.error('Error fetching variant:', error)
                  this.querySelector('.bundle-btn').classList.remove('loading')
                  alert('Error adding to cart. Please try again.')
                })
            } else {
              // No option_value_ids selected, fallback to pack button data-id
              const packSelected = this.querySelector('.product-pack.selected')
              if (packSelected) {
                const varId = parseVariantId(packSelected.getAttribute('data-var-id'))

                if (varId === null) {
                  showUnavailableState()
                  return
                }

                console.log(`Using pack default variant:`, varId)
                addArr.push({
                  id: varId,
                  quantity: 1,
                })
                addToCart()
              } else {
                this.querySelector('.bundle-btn').classList.remove('loading')
                alert('Please select a variant.')
              }
            }
          } else {
            // No swatch (single variant product)
            const packSelected = this.querySelector('.product-pack.selected')
            if (packSelected) {
              const varId = parseVariantId(packSelected.getAttribute('data-var-id'))

              if (varId === null) {
                showUnavailableState()
                return
              }

              console.log(`Adding single variant product:`, varId)
              addArr.push({
                id: varId,
                quantity: 1,
              })
              addToCart()
            }
          }
        })
      }, 20);
    }

    selectedWith = false
    selectedSize = 1

    hasAllSwatchSelected() {
      // Get the currently visible swatch based on selectedSize
      const currentSwatch = this.querySelector(`bundle-swatch[data-size="${this.selectedSize}"]`)

      if (!currentSwatch || currentSwatch.style.display === 'none') {
        return true // No visible swatch means no selection needed
      }

      // Count total number of option groups in the current swatch
      const totalOptions = currentSwatch.querySelectorAll('.swatch-single').length

      // Count number of selected options
      const selectedOptions = currentSwatch.querySelectorAll('.swatch-custom-image.swatch-selected').length

      console.log(`hasAllSwatchSelected: ${selectedOptions}/${totalOptions} options selected for size ${this.selectedSize}`)

      // All options must be selected
      return selectedOptions === totalOptions && totalOptions > 0
    }

    computePrice() {
      // Hide all price elements
      const allPriceIds = [
        'price-1x-single', 'price-1x-with',
        'price-2x-single', 'price-2x-with',
        'price-3x-single', 'price-3x-with'
      ]

      allPriceIds.forEach(id => {
        const el = document.getElementById(id)
        if (el) el.style.display = 'none'
      })

      console.log('computePrice - selectedSize:', this.selectedSize, 'selectedWith:', this.selectedWith)

      // Show the correct price based on size and with-bundle status
      let priceId = null

      if (this.selectedSize === 1) {
        priceId = this.selectedWith ? 'price-1x-with' : 'price-1x-single'
      } else if (this.selectedSize === 2) {
        priceId = this.selectedWith ? 'price-2x-with' : 'price-2x-single'
      } else if (this.selectedSize === 3) {
        priceId = this.selectedWith ? 'price-3x-with' : 'price-3x-single'
      }

      if (priceId) {
        const el = document.getElementById(priceId)
        if (el) {
          el.style.display = 'inline'
          console.log('Showing price:', priceId, el.textContent)
        } else {
          console.error('Price element not found:', priceId)
        }
      }
    }
  })

}

if (!customElements.get('bundle-swatch')) {
  customElements.define('bundle-swatch', class BundleSwatch extends HTMLElement {
    constructor() {
      super()

      setTimeout(() => {
        // Group swatches by option (each .swatch-single is an option group)
        const optionGroups = this.querySelectorAll('.swatch-single')

        optionGroups.forEach((optionGroup, groupIndex) => {
          const swatchesInGroup = optionGroup.querySelectorAll('.swatch-custom-image')
          const variantNameDisplay = optionGroup.querySelector('.swatch-variant-name')

          swatchesInGroup.forEach(item => item.addEventListener('click', e => {
            // Remove selected class from all swatches in THIS group only
            swatchesInGroup.forEach(swatch => swatch.classList.remove('swatch-selected'))

            const target = e.target.closest('.swatch-custom-image')
            target.classList.add('swatch-selected')

            // Update variant name for this specific option group
            if (variantNameDisplay) {
              variantNameDisplay.innerHTML = target.getAttribute('data-value')
            }

            this.checkSoldOutState(target)

            this.setAttribute(`data-selected-option${groupIndex + 1}`, target.getAttribute('data-value'))
          }))
        })

        if (this.style.display !== 'none') {
          this.checkSoldOutState()
        }
      }, 50);
    }

    checkSoldOutState() {
      const bundleSelector = this.closest('bundle-selector')
      if (!bundleSelector) return

      const selectedPack = bundleSelector.querySelector('.product-pack.selected')
      const selectedSize = selectedPack?.getAttribute('data-size')
      const activeSwatch = selectedSize
        ? bundleSelector.querySelector(`bundle-swatch[data-size="${selectedSize}"]`)
        : null
      const packUnavailable = !selectedPack
        || selectedPack.getAttribute('data-available') !== 'true'
        || !/^\d+$/.test(selectedPack.getAttribute('data-var-id') || '')
      const hasSoldOutSwatch = Boolean(
        activeSwatch?.querySelector('.swatch-custom-image.swatch-selected.sold-out')
      )
      const hasSoldOut = packUnavailable || hasSoldOutSwatch
      const addButton = bundleSelector.querySelector('.bundle-btn:not(.sold-out)')
      const soldOutButton = bundleSelector.querySelector('.bundle-btn.sold-out')

      if (document.querySelector('#BIS_trigger')) {
        if (hasSoldOut) {
          document.querySelector('#BIS_trigger').style.display = 'flex'
        } else {
          document.querySelector('#BIS_trigger').style.display = 'none'
        }
      }

      if (hasSoldOut) {
        bundleSelector.querySelector('.warning-text').style.display = 'none'
        if (addButton) addButton.style.display = 'none'
        if (soldOutButton) soldOutButton.style.display = 'flex'
      } else {
        if (addButton) addButton.style.display = 'flex'
        if (soldOutButton) soldOutButton.style.display = 'none'
      }
    }
  })
}
